import React from 'react';
import PropTypes from 'prop-types';

const HeatmapNotAvailable = ({ selectedBoundary }) => (
  <div className="SelectionNotAvailable container FootfallInsights_reports_grid_top content-card">
    <h3 className="SelectionNotAvailable_title">Heatmap doesn't support
    <br/>
    <br/>
    multiple {selectedBoundary.toLowerCase()} selections
    <br/>
    <br/>
    on this report</h3>
  </div>
);

HeatmapNotAvailable.propTypes = {
  selectedBoundary: PropTypes.string.isRequired,

};

export default HeatmapNotAvailable;
